import { createTheme, alpha } from "@mui/material/styles";

export const brand = {
  "50": "#9ef0f0",
  "100": "#7edce3",
  "200": "#3ddbd9",
  "300": "#08bdba",
  "400": "#009d9a",
  "500": "#007d79",
  "600": "#005d5d",
  "700": "#032B30",
  "800": "#022b30",
  "900": "#071A1C",
};
export const brandsecondary = {
  "50": "#def9f8",
  "100": "#acf0ed",
  "200": "#71e7e4",
  "300": "#00dcdc",
  "400": "#00d4d7",
  "500": "#00cbd4",
  "600": "#00bac1",
  "700": "#00a5a7",
  "800": "#00908f",
  "900": "#006c63",
};

export const gray = {
  50: "hsl(220, 35%, 97%)",
  100: "hsl(220, 30%, 94%)",
  200: "hsl(220, 20%, 88%)",
  300: "hsl(220, 20%, 80%)",
  400: "hsl(220, 20%, 65%)",
  500: "hsl(220, 20%, 42%)",
  600: "hsl(220, 20%, 35%)",
  700: "hsl(220, 20%, 25%)",
  800: "hsl(220, 30%, 6%)",
  900: "hsl(220, 35%, 3%)",
};

export const green = {
  50: "hsl(120, 80%, 98%)",
  100: "hsl(120, 75%, 94%)",
  200: "hsl(120, 75%, 87%)",
  300: "hsl(120, 61%, 77%)",
  400: "hsl(120, 44%, 53%)",
  500: "hsl(120, 59%, 30%)",
  600: "hsl(120, 70%, 25%)",
  700: "hsl(120, 75%, 16%)",
  800: "hsl(120, 84%, 10%)",
  900: "hsl(120, 87%, 6%)",
};

export const orange = {
  50: "hsl(45, 100%, 97%)",
  100: "hsl(45, 92%, 90%)",
  200: "hsl(45, 94%, 80%)",
  300: "hsl(45, 90%, 65%)",
  400: "hsl(45, 90%, 40%)",
  500: "hsl(45, 90%, 35%)",
  600: "hsl(45, 91%, 25%)",
  700: "hsl(45, 94%, 20%)",
  800: "hsl(45, 95%, 16%)",
  900: "hsl(45, 93%, 12%)",
};

export const red = {
  50: "hsl(0, 100%, 97%)",
  100: "hsl(0, 92%, 90%)",
  200: "hsl(0, 94%, 80%)",
  300: "hsl(0, 90%, 65%)",
  400: "hsl(0, 90%, 40%)",
  500: "hsl(0, 90%, 30%)",
  600: "hsl(0, 91%, 25%)",
  700: "hsl(0, 94%, 18%)",
  800: "hsl(0, 95%, 12%)",
  900: "hsl(0, 93%, 6%)",
};

var darkTheme = createTheme();

darkTheme = createTheme({
  typography: {
    fontFamily: ["Nunito Sans"].join(","),
    h1: {
      fontSize: darkTheme.typography.pxToRem(48),
      fontWeight: 600,
      lineHeight: 1.2,
      letterSpacing: -0.5,
    },
    h2: {
      fontSize: darkTheme.typography.pxToRem(36),
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: darkTheme.typography.pxToRem(30),
      lineHeight: 1.2,
    },
    h4: {
      fontSize: darkTheme.typography.pxToRem(24),
      fontWeight: 600,
      lineHeight: 1.5,
    },
    h5: {
      fontSize: darkTheme.typography.pxToRem(20),
      fontWeight: 600,
    },
    h6: {
      fontSize: darkTheme.typography.pxToRem(18),
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: darkTheme.typography.pxToRem(18),
    },
    subtitle2: {
      fontSize: darkTheme.typography.pxToRem(14),
      fontWeight: 500,
    },
    body1: {
      fontSize: darkTheme.typography.pxToRem(14),
    },
    body2: {
      fontSize: darkTheme.typography.pxToRem(14),
      fontWeight: 400,
    },
    caption: {
      fontSize: darkTheme.typography.pxToRem(12),
      fontWeight: 400,
    },
  },
  palette: {
    mode: "dark",
    primary: {
      contrastText: brand[50],
      light: brand[300],
      main: brand[400],
      dark: brand[700],
    },
    info: {
      contrastText: brand[300],
      light: brand[700],
      main: brand[700],
      dark: brand[900],
    },
    warning: {
      light: orange[400],
      main: orange[500],
      dark: orange[700],
    },
    error: {
      light: red[400],
      main: red[500],
      dark: red[700],
    },
    success: {
      light: green[400],
      main: green[500],
      dark: green[700],
    },
    grey: {
      ...gray,
    },
    divider: alpha(gray[50], 0.6),
    background: {
      default: gray[900],
      paper: brand[900],
    },
    text: {
      primary: "hsl(0, 0%, 100%)",
      secondary: gray[400],
    },
    action: {
      hover: alpha(gray[600], 0.2),
      selected: alpha(gray[600], 0.3),
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
});

darkTheme = {
  ...darkTheme,
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          backgroundColor: "white",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "& th": {
            backgroundColor: "transparent",
            fontWeight: "bold",
          },
          "& .MuiTableCell-root": {
            borderBottom: `0.5px solid white`,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "white",
            },
            "&:hover fieldset": {
              borderColor: "white",
            },
            "&.Mui-focused fieldset": {
              borderColor: "white",
            },
          },
          "& .MuiOutlinedInput-input": {
            color: "white",
          },
          "& .MuiInputLabel-root": {
            color: "white",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "white",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          color: "white",
          borderColor: "#00DCDC",
          "&:hover": {
            borderColor: "#00DCDC",
            backgroundColor: "lightblue",
            color: "black",
          },
        },
      },
    },
    // MuiChip: {
    //   styleOverrides: {
    //     root: {
    //       "&:hover": {
    //         backgroundColor: "yellow",
    //         color: "blue",
    //       },
    //       "&.MuiChip-clickable.MuiChip-selected": {
    //         backgroundColor: "lightblue",
    //         color: "white",
    //         "&:hover": {
    //           backgroundColor: "darkblue",
    //         },
    //       }
    //     },
    //     outlined: {
    //       "&:hover": {
    //         borderColor: "green",
    //       },
    //     },        
    //   },
    // },
  },
};

export default darkTheme;
